require('es6-promise').polyfill();
import 'nodelist-foreach-polyfill';
import GLightbox from '../node_modules/glightbox/dist/js/glightbox'; 
import Swiper from '../node_modules/swiper/swiper-bundle';
import accordion from './modules/accordeon';
import creditCard from './modules/creditCard';
import tabs from './modules/tabs';
import menu from './modules/menu';
import modal from './modules/modal';

window.addEventListener('DOMContentLoaded', () => { 
  // menu('.sidebar-arrow', '.sidebar', 'active');
  // try {
  //   tabs('.gallery-head', '.gallery-slider', '.gallery-header', 'active');
  // } catch (error) {}
  modal('[data-modal]', '.modal');
  try {
    creditCard();
  } catch (error) {}
  try {
    accordion('.products-menu__title');
  } catch (error) {}
  try {
    const heroSlider = new Swiper('.hero', {
      slidesPerView: 1,
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      },
      navigation: {
        nextEl: '#next',
        prevEl: '#prev',
      },
    });
  } catch (error) {}
  try { 
    function goodsSlider(parent, prev, next){
      const productsSlider = new Swiper(parent, {
        slidesPerView: 2,
        spaceBetween: 19,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        navigation: {
          prevEl: prev,
          nextEl: next,
        },
        breakpoints: {
          768: {
            slidesPerView: 3,
          },
          1024: {
            slidesPerView: 4,
          },
          1580: {
            slidesPerView: 5,
          }
        },
      });
    }
    goodsSlider('#products_1', '#prev_1', '#next_1');
    goodsSlider('#products_2', '#prev_2', '#next_2');
    goodsSlider('#products_3', '#prev_3', '#next_3');
  } catch (error) {}
  try {
    const galleryThumbs = new Swiper('.item-gallery__tumb', {
      spaceBetween: 10,
      slidesPerView: 4,
      freeMode: true,
      watchSlidesVisibility: true,
      watchSlidesProgress: true
    });
    const gallerySlider = new Swiper('.item-gallery__big', {
      slidesPerView: 1,
      slidesPerView: 1,
      slidesPerGroup: 1,
      spaceBetween: 60,
      centeredSlides: true,
      thumbs: {
        swiper: galleryThumbs
      }
    });
  } catch (error) {}

  try {
    jQuery(document).ready(function () {
      jQuery(".content").slice(0, 4).show();
      jQuery("#loadMore").on("click", function (e) {
        e.preventDefault();
        jQuery("#loadMore").text('Загружаю...')
        setTimeout(function () {
          jQuery(".content:hidden").slice(0, 4).slideDown();
          jQuery("#loadMore").text('Загрузить еще')
        }, 1000);
        if (jQuery(".content:hidden").length == 0) {
          jQuery("#loadMore").addClass("noContent");
        }
      });

    });
  } catch (error) {}
  
});